import { Button, Input, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'

import { Field, Modal } from '@mangovoice/mango-ui'

import { type MusicOnHoldTranslateFn, text } from '../types/i18n.types'

export interface CreatePlaylistModalProps {
  open: boolean
  onClose: () => void
  onSave: (name: string) => void
  isSaving?: boolean
  t?: MusicOnHoldTranslateFn
}

export const CreatePlaylistModal: React.FC<CreatePlaylistModalProps> = ({
  open,
  onClose,
  onSave,
  isSaving = false,
  t,
}) => {
  const [name, setName] = useState('')

  const handleClose = () => {
    setName('')
    onClose()
  }

  const isValid = name.trim().length > 0

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!isValid) return
    onSave(name.trim())
  }

  return (
    <Modal
      open={open}
      onOpenChange={(details) => !details.open && handleClose()}
      title={text(t, 'musicOnHold.createModal.title', 'New Playlist')}
      maxWidth="lg"
      footer={
        <>
          <Button borderRadius={'lg'} variant="outline" onClick={handleClose}>
            {text(t, 'musicOnHold.createModal.cancel', 'Close')}
          </Button>
          <Button
            type="submit"
            form="create-playlist-form"
            borderRadius={'lg'}
            colorPalette="brand"
            bg="brand.solid"
            color="brand.contrast"
            disabled={!isValid || isSaving}
            loading={isSaving}
          >
            {text(t, 'musicOnHold.createModal.submit', 'Create Playlist')}
          </Button>
        </>
      }
    >
      <form id="create-playlist-form" onSubmit={handleSubmit}>
        <VStack gap={5} align="stretch">
          <Field.Root required>
            <Field.Label>
              {text(t, 'musicOnHold.createModal.nameLabel', 'Name')}
            </Field.Label>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={text(
                t,
                'musicOnHold.createModal.namePlaceholder',
                'Enter playlist name',
              )}
              autoFocus
            />
          </Field.Root>
        </VStack>
      </form>
    </Modal>
  )
}
